import { IModuleTrackingData } from 'homepage/types/ModuleTrackingData';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { useState } from 'react';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { FeatureFlags } from 'featureFlags/constants';

const DEFAULT_DEBOUNCE_AMOUNT = 500;

/**
 * [useTriggerSwipeEvent]
 * Executes sending CMS module swipe event at a debounced  rate
 * @param  {IModuleTrackingData} moduleTrackingData Data to send w/ event
 * @return {Function}
 * Usage:
 *   useTriggerSwipeEvent(IModuleTrackingData)
 */
export const useTriggerSwipeEvent = (moduleTrackingData: IModuleTrackingData) => {
  const [debouncedSetScrollLeft, setDebouncedSetScrollLeft] = useState(null);
  const isNewSearchPageEnabled = useFeatureFlag(FeatureFlags.TEMP_WEB_ENABLE_SEARCH_MICROFRONTEND);

  const trackScrollEvent = () => {
    clearTimeout(debouncedSetScrollLeft);
    setDebouncedSetScrollLeft(
      setTimeout(() => {
        sendTrackingEvent('CMS_MODULE_SWIPE', {
          ...moduleTrackingData,
          service_name: isNewSearchPageEnabled ? 'consumer_search' : 'constructor',
        });
      }, DEFAULT_DEBOUNCE_AMOUNT),
    );
  };

  return {
    trackScrollEvent,
  };
};

export default useTriggerSwipeEvent;
